import axios from 'axios';

export default () => {
  const promise = new Promise((resolve, reject) => {
    axios
      .get(process.env.VUE_APP_API_ADMIN_LOCATION + 'providers/tiers')
      .then(({ data }) => {
        resolve(data.data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
